<script setup lang="ts">
import { ref } from 'vue'
import type { Simulation, SimulationDef, SimulationFormData } from '../../../../Types/simulation'
import FormCreator from '../UI/Form/FormCreator.vue'
import BlockContent from '../UI/Content/BlockContent.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import type { FormCreatorInstance } from '../UI/Form/formCreator'
import { useI18n } from 'vue-i18n'

interface Props {
  simulation: Simulation
  def: SimulationDef
}

const props = defineProps<Props>()

const { t } = useI18n()

const formLanguage = ref<FormCreatorInstance | null>(null)
const formData = ref<SimulationFormData>({})
function updateData(newData: SimulationFormData): void {
  formData.value = newData
}

const sending = ref<boolean>(false)
async function send(): Promise<void> {
  if (!formLanguage.value) {
    return
  }

  sending.value = true
  try {
    await formLanguage.value.methods('patch')
  } finally {
    sending.value = false
  }
}
</script>

<template>
  <div class="row" v-if="def.language">
    <div class="col-md-12">
      <BlockContent e2e-block="simulationLanguage">
        <FormCreator
          ref="formLanguage"
          src-error="formLanguage"
          endpoint="quotations"
          method="patch"
          class-to-add="d-none"
          :id="simulation.id"
          :config-def="def"
          :config-object="simulation"
          :params="{ simulationId: simulation.id }"
          dynamic
          @update-data="updateData"
        />
        <div class="row">
          <h4 class="col-md-6">{{ t('contract.information.language') }}</h4>
          <div class="col-md-6">
            <FieldCreator
              :form-data="formData"
              name="language"
              form-ref="formLanguage"
              domain="simulation"
              label-left
              type-value="string"
            />
            <div class="d-flex justify-content-end align-items-center flex-fill">
              <ButtonAll
                type="validation"
                margin="no"
                label="button.save"
                :loading="sending"
                :disabled="simulation.status === 'CANCELED'"
                @click="send"
              />
            </div>
          </div>
        </div>
      </BlockContent>
    </div>
  </div>
</template>
